export class Group {
  level = 0;
  parent: Group;
  expanded = true;
  get visible(): boolean {
    return !this.parent || (this.parent.visible && this.parent.expanded);
  }
}
